import "./App.scss";
import "bootstrap/scss/bootstrap.scss";
import "./custom.scss";
import "./modernCustom.scss";
import Home from "./views/Home";

function App() {
  return (
    <div className="appBg">
      <Home></Home>
    </div>
  );
}

export default App;
